import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-422b030e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pro__features" }
const _hoisted_2 = { class: "pro__features__title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pro__features__subtitle" }, null, -1))
const _hoisted_4 = { class: "pro__features" }
const _hoisted_5 = { class: "pro__features__title" }
const _hoisted_6 = { class: "pro__features__subtitle" }
const _hoisted_7 = { class: "pro__features" }
const _hoisted_8 = { class: "pro__features__title" }
const _hoisted_9 = { class: "pro__features__subtitle" }
const _hoisted_10 = { class: "pro__features" }
const _hoisted_11 = { class: "pro__features__title" }
const _hoisted_12 = { class: "pro__features__subtitle" }
const _hoisted_13 = { class: "pro__features" }
const _hoisted_14 = { class: "pro__features__title" }
const _hoisted_15 = { class: "pro__features__subtitle" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"margin-bottom":"20px"} }, null, -1))
const _hoisted_17 = { style: {"font-weight":"bold","font-size":"20px"} }
const _hoisted_18 = { class: "pro__features" }
const _hoisted_19 = { class: "pro__features__title" }
const _hoisted_20 = { class: "pro__features__subtitle" }
const _hoisted_21 = { class: "pro__features" }
const _hoisted_22 = { class: "pro__features__title" }
const _hoisted_23 = { class: "pro__features__subtitle" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"margin-bottom":"20px"} }, null, -1))
const _hoisted_25 = {
  key: 0,
  style: {"font-size":"14px","color":"grey","margin-bottom":"8px"}
}
const _hoisted_26 = {
  key: 1,
  style: {"font-size":"14px","color":"grey"}
}
const _hoisted_27 = { style: {"font-weight":"bold"} }
const _hoisted_28 = { style: {"margin-left":"auto"} }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"8px"} }, null, -1))
const _hoisted_30 = { style: {"font-weight":"bold"} }
const _hoisted_31 = { style: {"background":"#e80000","border-radius":"40px","font-weight":"bold","font-size":"13px","padding":"2px 8px","color":"white","margin-top":"auto","margin-bottom":"auto","margin-left":"4px"} }
const _hoisted_32 = { style: {"text-decoration":"line-through","font-size":"14px","margin":"auto 8px auto auto","color":"grey"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CModalTitle = _resolveComponent("CModalTitle")!
  const _component_CModalHeader = _resolveComponent("CModalHeader")!
  const _component_TimelapseIcon = _resolveComponent("TimelapseIcon")!
  const _component_Numeric1Icon = _resolveComponent("Numeric1Icon")!
  const _component_AccountMultipleIcon = _resolveComponent("AccountMultipleIcon")!
  const _component_MessageTextIcon = _resolveComponent("MessageTextIcon")!
  const _component_FileDocumentOutlineIcon = _resolveComponent("FileDocumentOutlineIcon")!
  const _component_CLoadingButton = _resolveComponent("CLoadingButton")!
  const _component_CModalBody = _resolveComponent("CModalBody")!
  const _component_CModal = _resolveComponent("CModal")!

  return (_openBlock(), _createBlock(_component_CModal, {
    visible: $props.visible,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
    alignment: "center",
    size: "lg"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_CModalHeader, { style: {"color":"black"} }, {
        default: _withCtx(() => [
          _createVNode(_component_CModalTitle, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('pro_features')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_CModalBody, { style: {"color":"black"} }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_TimelapseIcon, { class: "pro__features__icon" }),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('pro_minutes')), 1),
              _hoisted_3
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Numeric1Icon, { class: "pro__features__icon" }),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('pro_priority')), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('pro_priority_des')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_AccountMultipleIcon, { class: "pro__features__icon" }),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('pro_multi_speakers')), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('pro_multi_speakers_des')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_MessageTextIcon, { class: "pro__features__icon" }),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('pro_interact_with_audio')), 1),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('pro_interact_with_audio_des')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_FileDocumentOutlineIcon, { class: "pro__features__icon" }),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('pro_summary')), 1),
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('pro_summary_des')), 1)
            ])
          ]),
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('auto_renewal_clause')), 1),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('payment')), 1),
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('auto_renewal_payment_web')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('terms_and_conditions')), 1),
              _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('auto_renewal_terms_and_conditions')), 1)
            ])
          ]),
          _hoisted_24,
          (!$props.isAnonymous)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.$t('redirect_to_stripe')), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.$t('please_login_before_purchase')), 1)),
          _createElementVNode("div", null, [
            ($data.pro != null)
              ? (_openBlock(), _createBlock(_component_CLoadingButton, {
                  key: 0,
                  loading: $data.proLoading,
                  class: "purchase-button",
                  color: "light",
                  disabled: $data.proLoading,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.paymentClick($data.pro)))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('monthly')), 1),
                    _createElementVNode("label", _hoisted_28, _toDisplayString($options.filters.currency(
                $data.pro.currency_price.price,
                $data.pro.currency_price.currency,
              )), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"]))
              : _createCommentVNode("", true),
            _hoisted_29,
            ($data.proYear != null)
              ? (_openBlock(), _createBlock(_component_CLoadingButton, {
                  key: 1,
                  loading: $data.proYearLoading,
                  class: "purchase-button",
                  color: "light",
                  disabled: $data.proYearLoading,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.paymentClick($data.proYear)))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('annual')), 1),
                    _createElementVNode("label", _hoisted_31, _toDisplayString((
                (1 -
                  $data.proYear.currency_price.price /
                    ($data.pro.currency_price.price * 12)) *
                100
              ).toFixed(0) + '% OFF'), 1),
                    _createElementVNode("label", _hoisted_32, _toDisplayString($options.filters.currency(
                $data.pro.currency_price.price * 12,
                $data.pro.currency_price.currency,
              )), 1),
                    _createElementVNode("label", null, _toDisplayString($options.filters.currency(
                $data.proYear.currency_price.price,
                $data.proYear.currency_price.currency,
              )), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}